module.exports = __webpack_public_path__ + "static/media/bg-05@3x.72c92cd1.webp";